export const TwoFactorAuthenticationModal: string = 'TwoFactorAuthenticationModal';
